module.exports = __webpack_public_path__ + "static/codeImg.9b182622.jpg";